import { getPosts } from 'src/client/publication'
import { UseGetPostsProps } from 'src/client/publication/types'
import { AVATAR_SIZE, ROWS_POST_PER_PAGE } from 'src/utils/constants'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { COMMUNITY_TYPE } from 'src/pages/CommunityDetails/constants'
import { useInfiniteRequest } from '../useInfinityRequest'
import { useUser } from '../useUser'
import { REQUEST_CONFIG } from './useGetPosts.constants'

const useGetPosts = ({
  id,
  communityType,
  avatarSize = AVATAR_SIZE,
  filters,
  rows = ROWS_POST_PER_PAGE,
  enabled = true
}: UseGetPostsProps) => {
  const { authStatus } = useUser()

  const loggedOutLogic =
    authStatus === AuthStatus.UNAUTHENTICATED ? communityType === COMMUNITY_TYPE.PUBLIC : true

  const filtersToString = Object.entries(filters || {})
    .reduce<string[]>((acc, [key, value]) => {
      acc.push(`${key}:${value}`)
      return acc
    }, [])
    .toString()

  const baseCacheKey = filters?.pinned ? 'getPinnedPosts' : 'getPosts'
  const cacheKey = `communityId:${id}-rows:${rows}-communityType:${communityType}-${filtersToString}`

  return useInfiniteRequest(
    [baseCacheKey, cacheKey],
    /* istanbul ignore next */
    ({ pageParam }) => getPosts({ id, avatarSize, page: pageParam, filters, rows }),
    {
      enabled: loggedOutLogic && Boolean(id) && enabled,
      ...REQUEST_CONFIG,
      getNextPageParam: /* istanbul ignore next */ (lastPage) => {
        if (lastPage?.news?.page < Math.ceil(lastPage?.news?.size / rows) - 1) {
          return lastPage.news.page + 1
        }

        return undefined
      }
    }
  )
}

export default useGetPosts
